import React, { useState } from "react";
import { Row, Col, Modal, Button, Table } from "react-bootstrap";
import ProfileHook from "../../hook/user/ProfileHook";
import editicon from "../../Images/edit.png";
import deleteicon from "../../Images/delete.png";

import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { Helmet } from "react-helmet";

const UserProfile = () => {
  const { t } = useTranslation();
  const [inputs, setInputs] = useState([]);

  const [
    user,
    handleShow,
    handleClose,
    handleSubmit,
    show,
    firstname,
    lastname,
    mobile,
    email,
    onChangeFirstname,
    onChangeLastname,
    onChangeMobile,
    onChangeEmail,
    changePassword,
    oldpassword,
    newPassword,
    confirmPassword,
    onChangeOldPassword,
    onChangeNewPassword,
    onChangeConfirmPassword,
    allShippingMethods,
    onSelectedShippingMethod,
    showTable,
    webSiteData,
    oneShippingMethods,
    valueKeyInput,
    handleChangeInputKey,
    onSubmit,
    settingsRes,
    oneUser,
    wieghtNumber,
    wieghtCost,
    wieghtExtraCost,
    onChangewieghtCost,
    onChangewieghtNumber,
    onChangewieghtExtraCost,
    shippingId,
    showDelete,
    handleShowDelete,
    handleCloseDelete,
    handleDelete,
    confirmPasswordDeleteProfile,
onChangeConfirmPasswordDeleteProfile,
img,
onImageChange
  ] = ProfileHook();

  const primaryColor = settingsRes?.data?.cartColor || settingsRes?.data?.primaryColor || "#3182ce";

  return (
    <div className="font">
      {user.role == "admin" && (
        <Helmet>
          <title>
            {`${t("profile")}- ${
              Cookies.get("i18next") === "ar"
                ? settingsRes.data?.titleAr
                : settingsRes.data?.titleEn
            }`}{" "}
          </title>
        </Helmet>
      )}

      {/* Edit Profile Modal */}
      <Modal show={show} onHide={handleClose}>
        <div className="border-0 shadow-sm font">
          <Modal.Header className="bg-light border-bottom-0 pb-0">
            <Modal.Title className="fw-bold fs-5 text-dark font">
              <i className="fa-solid fa-user-pen me-2 text-primary"></i>
              {t("Modification of personal data")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-4 pb-0">
            {user?.role === "vendor" && (
              <div className="mb-4">
                <div className="text-muted fw-bold small mb-2">{t("profile image")}</div>
                <label htmlFor="upload-photo" style={{ cursor: "pointer" }}>
                  <img
                    src={img}
                    alt="profile"
                    height="80px"
                    width="80px"
                    className="rounded-circle border"
                    style={{ objectFit: "cover" }}
                  />
                </label>
                <input type="file" name="photo" onChange={onImageChange} id="upload-photo" className="d-none" />
              </div>
            )}
            <div className="mb-3">
              <label className="form-label text-muted fw-bold small">{t("first name")}</label>
              <input value={firstname} onChange={onChangeFirstname} type="text" className="form-control bg-light border-0 py-2 font" placeholder={t("first name")} />
            </div>
            <div className="mb-3">
              <label className="form-label text-muted fw-bold small">{t("last name")}</label>
              <input value={lastname} onChange={onChangeLastname} type="text" className="form-control bg-light border-0 py-2 font" placeholder={t("last name")} />
            </div>
            <div className="mb-3">
              <label className="form-label text-muted fw-bold small">{t("phone")}</label>
              <input value={mobile} onChange={onChangeMobile} type="text" className="form-control bg-light border-0 py-2 font" placeholder={t("phone")} />
            </div>
            <div className="mb-3">
              <label className="form-label text-muted fw-bold small">{t("email")}</label>
              <input value={email} onChange={onChangeEmail} type="text" className="form-control bg-light border-0 py-2 font" placeholder={t("email")} />
            </div>
          </Modal.Body>
          <Modal.Footer className="border-top-0 pt-0">
            <Button className="font px-4 py-2 fw-bold" variant="light" onClick={handleClose}>
              {t("retreat")}
            </Button>
            <Button className="font px-5 py-2 fw-bold text-white border-0" style={{ backgroundColor: primaryColor, borderRadius: '8px' }} onClick={handleSubmit}>
              {t("save")}
            </Button>
          </Modal.Footer>
        </div>
      </Modal>

      {/* Delete Profile Modal */}
      <Modal show={showDelete} onHide={handleCloseDelete}>
        <div className="border-0 shadow-sm font">
          <Modal.Header className="bg-light border-bottom-0 pb-0">
            <Modal.Title className="fw-bold fs-5 text-danger font">
              <i className="fa-solid fa-triangle-exclamation me-2"></i>
              {t("Confirm deletion")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-4">
            <p className="text-muted mb-3">{t("confirm password")}</p>
            <input
              value={confirmPasswordDeleteProfile}
              onChange={onChangeConfirmPasswordDeleteProfile}
              placeholder={t("confirm password")}
              type="password"
              className="form-control bg-light border-0 py-2 font"
            />
          </Modal.Body>
          <Modal.Footer className="border-top-0 pt-0">
            <Button className="font px-4 py-2 fw-bold" variant="light" onClick={handleCloseDelete}>
              {t("retreat")}
            </Button>
            <Button className="font px-4 py-2 fw-bold" variant="danger" onClick={handleDelete}>
              {t("delete")}
            </Button>
          </Modal.Footer>
        </div>
      </Modal>

      {/* Profile Info Card */}
      <div className="checkout-section-card mb-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div className="checkout-section-title mb-0">
            <i className="fa-solid fa-user-circle"></i>
            {t("profile")}
          </div>
          <div className="d-flex gap-2">
            <button className="btn btn-sm btn-outline-primary fw-bold px-3 font" onClick={handleShow}>
              <i className="fa-solid fa-pen me-2"></i>
              {t("Modify")}
            </button>
            <button className="btn btn-sm btn-outline-danger fw-bold px-3 font" onClick={handleShowDelete}>
              <i className="fa-solid fa-trash-can me-2"></i>
              {t("delete")}
            </button>
          </div>
        </div>

        <Row className="g-3">
          <Col md={6}>
            <div className="p-3 bg-light rounded-3">
              <div className="text-muted small fw-bold mb-1">{t("name")}</div>
              <div className="fw-bold text-dark">{`${user.firstname} ${user.lastname}`}</div>
            </div>
          </Col>
          <Col md={6}>
            <div className="p-3 bg-light rounded-3">
              <div className="text-muted small fw-bold mb-1">{t("email")}</div>
              <div className="fw-bold text-dark">{user.email}</div>
            </div>
          </Col>
          <Col md={6}>
            <div className="p-3 bg-light rounded-3">
              <div className="text-muted small fw-bold mb-1">{t("phone")}</div>
              <div className="fw-bold text-dark" dir="ltr">{user.mobile}</div>
            </div>
          </Col>
        </Row>
      </div>

      {/* Change Password Card */}
      <div className="checkout-section-card mb-4">
        <div className="checkout-section-title">
          <i className="fa-solid fa-lock"></i>
          {t("change password")}
        </div>

        <Row>
          <Col md={6}>
            <div className="mb-3">
              <label htmlFor="oldPassword" className="form-label text-muted fw-bold small">{t("old password")}</label>
              <input id="oldPassword" value={oldpassword} onChange={onChangeOldPassword} type="password" className="form-control bg-light border-0 py-2 font" placeholder={t("enter old password")} />
            </div>
            <div className="mb-3">
              <label htmlFor="newPassword" className="form-label text-muted fw-bold small">{t("new password")}</label>
              <input id="newPassword" value={newPassword} onChange={onChangeNewPassword} type="password" className="form-control bg-light border-0 py-2 font" placeholder={t("enter new password")} />
            </div>
            <div className="mb-3">
              <label htmlFor="verifyPassword" className="form-label text-muted fw-bold small">{t("confirm password")}</label>
              <input id="verifyPassword" value={confirmPassword} onChange={onChangeConfirmPassword} type="password" className="form-control bg-light border-0 py-2 font" placeholder={t("confirm new password")} />
            </div>
            <button onClick={changePassword} className="btn text-white fw-bold px-4 py-2 font" style={{ backgroundColor: primaryColor, borderRadius: '8px' }}>
              {t("save")}
            </button>
          </Col>
        </Row>
      </div>

      {/* Shipping Method Card (Admin/Vendor only) */}
      {((user.role == "admin" && webSiteData.MULTI_VENDOR == "false") || user.role == "vendor") && (
        <div className="checkout-section-card">
          <div className="checkout-section-title">
            <i className="fa-solid fa-truck"></i>
            {t("Select a shipping method")}
          </div>

          <select
            name="allShippingMethods"
            onChange={onSelectedShippingMethod}
            value={shippingId}
            className="checkout-address-select mb-4"
          >
            <option value="0">{t("Select a shipping method")}</option>
            {allShippingMethods && allShippingMethods.map((el) => (
              <option key={el._id} value={el._id}>
                {Cookies.get("i18next") == "ar" ? el.nameAr : el.nameEn}
              </option>
            ))}
          </select>

          {showTable && (
            <div>
              <Row className="g-3 mb-4">
                <Col md={4}>
                  <label className="form-label text-muted fw-bold small" htmlFor="wieghtCost">{t("Shipping method wieghtCost")}</label>
                  <input id="wieghtCost" value={wieghtCost} onChange={onChangewieghtCost} type="number" className="form-control bg-light border-0 py-2 font" placeholder={t("Shipping method cost")} />
                </Col>
                <Col md={4}>
                  <label className="form-label text-muted fw-bold small" htmlFor="wieghtNumber">{t("Shipping method wieghtNumber")}</label>
                  <input id="wieghtNumber" value={wieghtNumber} onChange={onChangewieghtNumber} type="number" className="form-control bg-light border-0 py-2 font" placeholder={t("Shipping method cost")} />
                </Col>
                <Col md={4}>
                  <label className="form-label text-muted fw-bold small" htmlFor="wieghtExtraCost">{t("Shipping method wieghtExtraCost")}</label>
                  <input id="wieghtExtraCost" value={wieghtExtraCost} onChange={onChangewieghtExtraCost} type="number" className="form-control bg-light border-0 py-2 font" placeholder={t("Shipping method cost")} />
                </Col>
              </Row>

              <Table striped bordered hover responsive className="mb-3">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>{t("Key")}</th>
                    <th>{t("Value")}</th>
                  </tr>
                </thead>
                <tbody>
                  {oneShippingMethods?.settingsData?.map((el, key) => (
                    <tr key={key}>
                      <td>{el.count}</td>
                      <td>{el.key}</td>
                      <td>
                        <input
                          name="value"
                          value={valueKeyInput ? valueKeyInput[key]?.value : ""}
                          onChange={(e) => handleChangeInputKey(e, key)}
                          className="form-control form-control-sm bg-light border-0 font"
                          type="text"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="d-flex justify-content-end">
                <button onClick={onSubmit} className="btn text-white fw-bold px-4 py-2 font" style={{ backgroundColor: primaryColor, borderRadius: '8px' }}>
                  {t("save")}
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      <ToastContainer />
    </div>
  );
};

export default UserProfile;
